import instance from "../";
import type { Account } from "./account";

export const createOnfidoApplicant = async (accountID: string) => {
  const { data } = await instance.post<Account>(
    `/accounts/${accountID}/onfido/applicant`,
  );
  return data;
};

export const updateOnfidoApplicant = async (accountID: string) => {
  const { data } = await instance.patch(
    `/accounts/${accountID}/onfido/applicant`,
  );
  return data;
};

export const getOnfidoSdkToken = async (accountID: string) => {
  const { data } = await instance.get<{ onfido_sdk_token: string }>(
    `/accounts/${accountID}/onfido/sdk_token`,
  );
  return data;
};

type OnfidoSDKOutcomes = "SDK_ERROR" | "USER_COMPLETED";
export type PatchOnfidoParams = {
  accountID: string;
  outcome: OnfidoSDKOutcomes;
  token: string;
};
export const patchOnfidoSdkToken = async ({
  accountID,
  ...rest
}: PatchOnfidoParams) => {
  const { data } = await instance.patch(
    `/accounts/${accountID}/onfido/sdk`,
    rest,
  );
  return data;
};

export type OnfidoWorkflowRunResponse = {
  onfido_sdk_token: string;
  onfido_workflow_run_id: string;
};

export const createOnfidoWorkflowRun = async (accountID: string) => {
  const { data } = await instance.post<OnfidoWorkflowRunResponse>(
    `/accounts/${accountID}/onfido/workflow_run`,
  );
  return data;
};
